/* frontend/src/components/AnimatedSocialLinks.js */
import React from 'react';
import FuzzyText from './FuzzyText';
import './AnimatedSocialLinks.css';

export const socials = [
  { name: 'Twitter', icon: 'fab fa-x-twitter', url: 'https://x.com/SErraNDservices?t=jgA6iFpxybZByKhjk6I1pw&s=09' },
  { name: 'Facebook', icon: 'fab fa-facebook-f', url: 'https://www.facebook.com/profile.php?id=61578018524596' },
  { name: 'Instagram', icon: 'fab fa-instagram', url: 'https://www.instagram.com/serrand_services/' },
  { name: 'TikTok', icon: 'fab fa-tiktok', url: 'https://www.tiktok.com/@serrand.services?lang=en' },
  { name: 'LinkedIn', icon: 'fab fa-linkedin-in', url: 'https://ke.linkedin.com/in/serrand-services-15120336b' },
  { name: 'WhatsApp', icon: 'fab fa-whatsapp', url: 'https://wa.me/254740879229' },
];

const AnimatedSocialLinks = ({ className = '' }) => {
  return (
    <div className={`animated-social-links ${className}`}>
      {socials.map((social, index) => (
        <a
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="relative cursor-pointer py-2"
          key={index}
          aria-label={`Visit SErraND on ${social.name}`}
          style={{ '--index': index }}
        >
          <FuzzyText
            fontSize="0.875rem"
            fontWeight={500}
            fontFamily="'Poppins', sans-serif"
            color="#dfe6e9"
            baseIntensity={0.15}
            hoverIntensity={0.4}
            enableHover={true}
          >
            {social.name}
          </FuzzyText>
          <i className={`${social.icon} text-3xl`} />
        </a>
      ))}
    </div>
  );
};

export default AnimatedSocialLinks;
